import { LanguageCodeEnum, LocaleEnum } from '@systemeio/types'

export { LanguageCodeEnum, LocaleEnum }

export const localeNames = {
  [LocaleEnum.ENGLISH]: 'English',
  [LocaleEnum.FRENCH]: 'Français',
  [LocaleEnum.SPANISH]: 'Español',
  [LocaleEnum.ITALIAN]: 'Italiano',
  [LocaleEnum.PORTUGUESE]: 'Português',
  [LocaleEnum.DEUTSCH]: 'Deutsch',
  [LocaleEnum.DUTCH]: 'Nederlands',
  [LocaleEnum.RUSSIAN]: 'Русский',
  [LocaleEnum.JAPANESE]: '日本語',
  [LocaleEnum.ARABIC]: 'عربي',
  [LocaleEnum.TURKISH]: 'Türkçe',
  [LocaleEnum.CHINESE]: '中文(简体)',
  [LocaleEnum.SWEDISH]: 'Svenska',
  [LocaleEnum.ROMANIAN]: 'Română',
  [LocaleEnum.CZECH]: 'Čeština',
  [LocaleEnum.HUNGARIAN]: 'Magyar',
  [LocaleEnum.SLOVAK]: 'Slovenský',
  [LocaleEnum.DANISH]: 'Dansk',
  [LocaleEnum.INDONESIAN]: 'Indonesian',
  [LocaleEnum.POLISH]: 'Polski',
  [LocaleEnum.GREEK]: 'Ελληνικά',
  [LocaleEnum.SERBIAN]: 'Srpski',
  [LocaleEnum.HINDI]: 'Hindi',
  [LocaleEnum.NORWEGIAN]: 'Norsk',
  [LocaleEnum.THAI]: 'ไทย',
  [LocaleEnum.SLOVENIAN]: 'Slovenski',
  [LocaleEnum.UKRAINIAN]: 'Український',
  [LocaleEnum.ALBANIA]: 'Shqiptare',
} satisfies Record<LocaleEnum, string>

const languageCodeByLocale = {
  [LocaleEnum.ENGLISH]: LanguageCodeEnum.ENGLISH,
  [LocaleEnum.FRENCH]: LanguageCodeEnum.FRENCH,
  [LocaleEnum.SPANISH]: LanguageCodeEnum.SPANISH,
  [LocaleEnum.ITALIAN]: LanguageCodeEnum.ITALIAN,
  [LocaleEnum.PORTUGUESE]: LanguageCodeEnum.PORTUGUESE,
  [LocaleEnum.DEUTSCH]: LanguageCodeEnum.DEUTSCH,
  [LocaleEnum.DUTCH]: LanguageCodeEnum.DUTCH,
  [LocaleEnum.RUSSIAN]: LanguageCodeEnum.RUSSIAN,
  [LocaleEnum.JAPANESE]: LanguageCodeEnum.JAPANESE,
  [LocaleEnum.ARABIC]: LanguageCodeEnum.ARABIC,
  [LocaleEnum.TURKISH]: LanguageCodeEnum.TURKISH,
  [LocaleEnum.CHINESE]: LanguageCodeEnum.CHINESE,
  [LocaleEnum.SWEDISH]: LanguageCodeEnum.SWEDISH,
  [LocaleEnum.ROMANIAN]: LanguageCodeEnum.ROMANIAN,
  [LocaleEnum.CZECH]: LanguageCodeEnum.CZECH,
  [LocaleEnum.HUNGARIAN]: LanguageCodeEnum.HUNGARIAN,
  [LocaleEnum.SLOVAK]: LanguageCodeEnum.SLOVAK,
  [LocaleEnum.DANISH]: LanguageCodeEnum.DANISH,
  [LocaleEnum.INDONESIAN]: LanguageCodeEnum.INDONESIAN,
  [LocaleEnum.POLISH]: LanguageCodeEnum.POLISH,
  [LocaleEnum.GREEK]: LanguageCodeEnum.GREEK,
  [LocaleEnum.SERBIAN]: LanguageCodeEnum.SERBIAN,
  [LocaleEnum.NORWEGIAN]: LanguageCodeEnum.NORWEGIAN,
  [LocaleEnum.THAI]: LanguageCodeEnum.THAI,
  [LocaleEnum.SLOVENIAN]: LanguageCodeEnum.SLOVENIAN,
  [LocaleEnum.UKRAINIAN]: LanguageCodeEnum.UKRAINIAN,
  [LocaleEnum.ALBANIA]: LanguageCodeEnum.ALBANIA,
  [LocaleEnum.HINDI]: LanguageCodeEnum.HINDI,
} satisfies Record<LocaleEnum, LanguageCodeEnum>

export const getLanguageCodeByLocale = (locale: LocaleEnum): LanguageCodeEnum =>
  languageCodeByLocale[locale]
